module.exports = __webpack_public_path__ + "static/2front-positions-2-d636f4b5557f271af861a52650f6bf7d.png";